import React from 'react';
import { t } from 'Src/i18n';
import { computePriceInCents } from 'Components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater.utils';
import { UpliftPrice } from './UpliftPrice';

export const UpliftSelector = ({ price, iconClassname }) => {
  return (
    <div id="up-pay-monthly-selector">
      <span>{t('booking.banking.paymentSchedule.payMonthly')}</span>
      <UpliftPrice
        id="up-pay-monthly-selector-from-pricing"
        iconClassname={iconClassname}
        className="font-bold text-sienna"
        data-up-price-type="total"
        data-up-price-value={computePriceInCents(price)}
      />
    </div>
  );
};
